// SPDX-License-Identifier: AGPL-3.0-or-later
// Copyright (C) 2025-2026 Daragh Farrell

import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { isNativePlatform } from '../utils/platform';

/**
 * Listens for deep link URL opens on native platforms (Capacitor).
 * Parses the URL and navigates to the matching React Router path.
 * No-op on web platform.
 */
export function useDeepLinks(): void {
  const navigate = useNavigate();

  useEffect(() => {
    if (!isNativePlatform()) return;

    let cleanup: (() => void) | undefined;

    import('@capacitor/app').then(({ App }) => {
      App.addListener('appUrlOpen', (event) => {
        try {
          const url = new URL(event.url);
          const path = url.pathname + url.search;
          if (path && path !== '/') {
            navigate(path);
          }
        } catch {
          // Invalid URL — ignore
        }
      }).then((handle) => {
        cleanup = () => handle.remove();
      });
    });

    return () => {
      cleanup?.();
    };
  }, [navigate]);
}
